import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const SharedSettingsStyleParts = ['wrapper'] as const

const helpers = createMultiStyleConfigHelpers(SharedSettingsStyleParts)

export const SharedSettingsStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    wrapper: {
      display: 'flex',
      padding: '2.5rem',
      width: '100%',
      height: '100%',
      flexDirection: 'column',
      gap: '1.25rem',
      overflowY: 'auto',
    },
  },
})

export const useSharedSettingsStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof SharedSettingsStyleParts>(
    getName({ SharedSettingsStyle }),
    props,
  )
}
